@if (person) {
  <div class="flex w-full flex-col items-start gap-6 lg:flex-row lg:gap-6">
    <!-- Author Name Section - Left 50% -->
    <div class="w-full lg:flex-grow lg:basis-2/3">
      <div
        class="self-stretch text-4xl leading-tight font-normal text-gradient-start md:text-6xl lg:text-8xl lg:leading-tight"
      >
        {{ person | formatAuthorName }}
      </div>
    </div>
    <!-- Links Section - Right 50% -->
    @if (hasLinks()) {
      <div
        class="flex h-full w-full flex-col justify-start self-start lg:basis-1/3"
      >
        <!-- Links Section -->
        <div>
          <!-- Institute/Department Link -->
          @if (getDepartment()) {
            <div
              class="inline-flex w-full items-center justify-between gap-5 border-b border-black/20 py-3"
            >
              <div
                class="text-lg leading-normal font-medium text-neutral-800 md:w-72"
              >
                {{ getDepartment() }}
              </div>
            </div>
          }
          <!-- Company Name -->
          @if (getCompanyName()) {
            <div
              class="inline-flex w-full items-center justify-between gap-5 border-b border-black/20 py-3"
            >
              <div
                class="text-lg leading-normal font-medium text-neutral-800 md:w-72"
              >
                {{ getCompanyName() }}
              </div>
            </div>
          }
          <!-- Firm Page Link -->
          @if (getFirmPage()) {
            <a
              class="inline-flex w-full items-center justify-between gap-5 border-b border-black/20 py-3 hover:bg-gray-50"
              [href]="getFirmPage()"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div
                class="text-lg leading-normal font-medium text-neutral-800 md:w-72"
              >
                {{ 'common.social.firmPage' | translate }}
              </div>
              <div class="flex items-center justify-start gap-5 px-2">
                <div class="relative">
                  <svg
                    class="h-6 w-6"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 18L18 6M18 6H10M18 6V14"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </a>
          }
          <!-- LinkedIn Link -->
          @if (getSocialLink()) {
            <a
              class="inline-flex w-full items-center justify-between gap-5 border-b border-black/20 py-3 hover:bg-gray-50"
              [href]="getSocialLink()"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div
                class="text-lg leading-normal font-medium text-neutral-800 md:w-72"
              >
                LinkedIn
              </div>
              <div class="flex items-center justify-start gap-5 px-2">
                <div class="relative">
                  <svg
                    class="h-6 w-6"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 18L18 6M18 6H10M18 6V14"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </a>
          }
        </div>
      </div>
    }
  </div>
}
